import ExpandLess from '@mui/icons-material/ExpandLess';
import {
    Card,
    List,
    ListItem,
    ListItemText,
    Typography,
    Button,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    CardActions
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ResumenProducts } from 'types/components/shared';

const CardRatings = ({
    resume,
    sumaValores,
    setTypeScore,
    typeScore
}: {
    resume: ResumenProducts;
    sumaValores: () => number;
    setTypeScore: any;
    typeScore: 'Good' | 'Fair' | 'Poor' | string;
}) => {
    const intl = useIntl();
    const theme = useTheme();

    const handleClickDetail = (type: string) => {
        setTypeScore(type);
    };

    const renderPercentage = (value?: number) => {
        const percent = (value ?? 0) / 100;

        return intl.formatNumber(percent, {
            style: 'percent',
            maximumFractionDigits: 2,
            localeMatcher: 'best fit'
        });
    };

    const colorCode = useMemo(() => {
        if (resume?.description === 'Good') return 'success';
        if (resume?.description === 'Fair') return 'warning';

        return 'error';
    }, [resume?.description]);

    return (
        <>
            <Card
                elevation={typeScore === resume.description ? 2 : 0}
                sx={{
                    width: '100%',
                    borderRadius: '10px',

                    // background: typeScore === resume.description ? theme.palette.background.default : theme.palette.background.paper,
                    background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                    border: 1,
                    borderColor: typeScore === resume.description ? theme.palette.primary.main : 'transparent',
                    transition: 'all 340ms linear',
                    '&:hover': {
                        border: `1px solid${theme.palette.primary.main}`
                    }
                }}
            >
                <CardContent sx={{ p: 1, pb: 0 }}>
                    <Accordion sx={{ background: 'rgba(250,250,250, 0)' }}>
                        <AccordionSummary expandIcon={<ExpandLess />}>
                            <Typography variant="h3" sx={{ mr: 1 }}>
                                {intl.formatMessage({ id: `${resume?.description}` })}
                            </Typography>
                            <Typography variant="h3">{renderPercentage(resume?.totalProductsPercentage)}</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0 }}>
                            <List disablePadding sx={{ p: 0 }}>
                                <ListItem>
                                    <ListItemText primary={intl.formatMessage({ id: 'Dimension-Score' })} />
                                    {renderPercentage(resume.dimensionScorePercen)}
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary={intl.formatMessage({ id: 'Quality_Score' })} />
                                    {renderPercentage(resume.qualityScorePercen)}
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary={intl.formatMessage({ id: 'Quantity_Score' })} />
                                    {renderPercentage(resume.quantityScorePerce)}
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary={intl.formatMessage({ id: 'Size_Score' })} />
                                    {renderPercentage(resume.sizeScorePercen)}
                                </ListItem>
                            </List>
                        </AccordionDetails>
                    </Accordion>
                </CardContent>{' '}
                <CardActions sx={{ justifyContent: 'space-between' }}>
                    <Typography variant="caption">
                        {`${intl.formatMessage({ id: 'Products' })}: ${intl.formatNumber(resume.totalProducts ?? 0, {
                            style: 'unit'
                            // currency: 'MXN'
                        })} / ${intl.formatNumber(sumaValores())}`}
                    </Typography>
                    <Button
                        onClick={() => handleClickDetail(resume?.description)}
                        variant="outlined"
                        size="small" // eslint-disable-next-line no-nested-ternary
                        color={colorCode}
                    >
                        {intl.formatMessage({ id: 'details' })}
                    </Button>
                </CardActions>
            </Card>
        </>
    );
};

export default CardRatings;
// resume?.totalProductsPercentage?.toFixed(2)}%
